import { graphql, useStaticQuery } from "gatsby"

export default function useGlobalFlyers() {
  const data = useStaticQuery(graphql`
    query flyersQuery {
      globals(handle: { eq: "flyers" }) {
        flyers {
          locale
          document {
            url
          }
        }
      }
    }
  `)

  return data.globals?.flyers
}